import { css } from 'styled-components';
import { HealthcareTransitionViewProps } from './models';

export const HealthcareTransitionView = css<HealthcareTransitionViewProps>(({ theme }) => {
  return css`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    > .info {
      flex: 1;

      > .total-amount-title {
        font-size: 25px;
        font-style: normal;
        font-weight: 800;
        line-height: 34px;
        color: ${theme.colors.primaryDeepBlue};
        white-space: pre-wrap;
        margin-top: 62px;
        max-width: 494px;

        @media only screen and ${theme.device.mobileXL} {
          line-height: 30px;
          max-width: 327px;
          white-space: normal;
        }

        > .amount {
          font-size: 25px;
          color: ${theme.colors.primaryBright};
        }
      }

      > .down-payment-notice {
        color: ${theme.colors.darkGray};
        font-size: 10px;
        font-weight: 400;
      }
    }

    > .slogan {
      margin-bottom: 20px;
    }
  `;
});
